import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { API_BASE_URL } from "../../config.js";
import { FaEye } from "react-icons/fa";

const AssetsList = () => {
  const [records, setRecords] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchAssets();
  }, []);

  const fetchAssets = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const res = await axios.get(API_BASE_URL + "/myasset_list", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const formatted = res.data.data.map((row) => ({
        assets_id: row.assets_id,
        asset_title: row.asset_title,
        category_name: row.category_name,
        company_asset_code: row.company_asset_code,
        status_name: row.status_name,
        department_name: row.department_name,
        unit_price: row.unit_price,
      }));

      setRecords(formatted);
    } catch (err) {
      console.error("Failed to load asset list:", err);
    }
  };

  const filteredItems = records.filter((item) =>
    `${item.asset_title} ${item.category_name} ${item.company_asset_code} ${item.status_name} ${item.department_name}`
      .toLowerCase()
      .includes(filterText.toLowerCase())
  );

  const handleView = (row) => {
    window.location.href = `/Asset-info/${row.assets_id}`;
  };

  const downloadCSV = () => {
    if (!filteredItems.length) return;

    const header = [
      "Asset Name",
      "Category",
      "Asset Code",
      "Status",
      "Department",
      "Unit Price",
    ];

    const rows = filteredItems.map((a) => [
      a.asset_title,
      a.category_name,
      a.company_asset_code,
      a.status_name,
      a.department_name,
      a.unit_price,
    ]);

    const csvContent =
      [header, ...rows]
        .map((row) =>
          row.map((value) =>
            `"${(value ?? "").toString().replace(/"/g, '""')}"`
          ).join(",")
        )
        .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "My_Assets.csv";
    link.click();
  };

  const columns = [
    {
      name: "Action",
      width: "80px",
      cell: (row) => (
        <button
          onClick={() => handleView(row)}
          className="btn p-1"
          style={{ background: "transparent", border: "none" }}
        >
          <FaEye size={16} />
        </button>
      ),
    },
    { name: "Asset Name", selector: (row) => row.asset_title, sortable: true },
    { name: "Category", selector: (row) => row.category_name, sortable: true },
    { name: "Asset Code", selector: (row) => row.company_asset_code, sortable: true },
    { name: "Status", selector: (row) => row.status_name, sortable: true },
    { name: "Department", selector: (row) => row.department_name, sortable: true },
    { name: "Unit Price", selector: (row) => row.unit_price, sortable: true },
  ];

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h6 className="mb-0">My Assets</h6>

          <input
            type="text"
            placeholder="Search..."
            className="form-control form-control-sm"
            style={{ width: "200px" }}
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </div>

        <div className="card-body">

          <button className="btn btn-success btn-sm mb-3" onClick={downloadCSV}>
            <i className="fa fa-file-csv"></i>  CSV
          </button>

          <DataTable
            columns={columns}
            data={filteredItems}
            pagination
            highlightOnHover
            striped
            responsive
          />
        </div>
      </div>
    </div>
  );
};

export default AssetsList;
